export const useAvailabilitySummaryReportColumns = () => {
  return [
    {
      headerName: 'Assignment',
      field: 'assignment',
      align: 'left',
      minWidth: 110,
    },
    {
      headerName: 'Day: available',
      field: 'day_available',
      flex: 1,
      minWidth: 110,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => params.value || '-',
    },
    {
      headerName: 'Unavailable',
      field: 'day_unavailable',
      flex: 1,
      maxWidth: 95,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => params.value || '-',
    },
    {
      headerName: 'No record',
      field: 'day_no_record',
      flex: 1,
      maxWidth: 95,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => params.value || '-',
    },
    {
      headerName: 'Night: Available',
      field: 'night_available',
      flex: 1,
      minWidth: 110,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => params.value || '-',
    },
    {
      headerName: 'Unavailable',
      field: 'night_unavailable',
      flex: 1,
      maxWidth: 95,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => params.value || '-',
    },
    {
      headerName: 'No Record',
      field: 'night_no_record',
      flex: 1,
      maxWidth: 95,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => params.value || '-',
    },
  ];
};

export default useAvailabilitySummaryReportColumns;
